export default "__VITE_ASSET__B8YPFR5L__"